import React from 'react';

import { renderLoadingIcon } from '../../components/loadingIcon/loadingIcon';

import './loading.scss';

interface LoadingProps {
    loadingText?: string;
}

class Loading extends React.Component<LoadingProps> {
    private renderText(): JSX.Element | null {
        if (this.props.loadingText) {
            return <div className='loading-text'>{this.props.loadingText}</div>;
        }

        return null;
    }

    public render() {
        return (
            <div className='loading-container'>
                {renderLoadingIcon('responsive-loading')}
                {this.renderText()}
            </div>
        );
    }
}

export default Loading;